export default __webpack_public_path__ + "static/media/close-popup.4ab28365.svg";